import * as types from '../constants/actionTypes';
import { DEFAULT_PAGE_SIZE, TASK_LIST_MENU_ITEMS } from '../constants/constants';

const initialState = {
    searchParams: {
        isMobile: false,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: 1,
        sortBy: "targetDate",
        sortDir: "asc",
        name: '',
        locationKeys: [],
        taskId: '',
        projectIds: [],
        targetDateStart: null,
        targetDateEnd: null,
        startDateStart: null,
        startDateEnd: null,
        responsibleUserName: '',
        statusIds: [],
        departmentIds: [],
        disciplineId: '',
        communityIds: [],
        phaseIds: [],
        additionalInfo: '',
        baselineName: '',
        recentlyUpdated: null,
        tagIds: []
    },
    locations: [],
    defaultLocationKey: '',
    tasksMenuItems: [],
    tasksMenuSelectedValue: TASK_LIST_MENU_ITEMS.AllTasks.value,
    tasksPageTasksMenuItems: []
};

export default function locationTaskListReducer(state = initialState, action) {
    switch(action.type) {
        case types.SET_LOCATION_FILTER_STATE: {
            return {
                ...state,
                searchParams: action.payload.searchParams
            };
        }
        case types.SET_LOCATION_KEY_STATE: {
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    locationKeys: action.payload.locationKeys
                }
            };
        }
        case types.SET_LOCATION_SELECTOR_FILTERS: {
            return {
                ...state,
                locations: action.payload.locations,
                defaultLocationKey: action.payload.defaultLocationKey
            };
        }
        case types.SET_TASK_MENU_SELECTED: {
            return {
                ...state,
                tasksMenuSelectedValue: action.payload.selectedValue
            };
        }
        case types.SET_TASK_MENU_ITEMS: {
            return {
                ...state,
                tasksMenuItems: [...action.payload.items]
            };
        }
        case types.SET_TASK_PAGE_TASK_MENU_ITEMS: {
            return {
                ...state,
                tasksPageTasksMenuItems: [...action.payload.items]
            };
        }
        default:
            return state;
    }
}
